import { defineMessages } from 'utils/intl';

export default defineMessages({
  button: 'Zamów teraz,',
  buttonTommorow: 'otrzymasz jutro',
  buttonAfterTommorow: 'otrzymasz pojutrze',
  buttonAfterDays: 'otrzymasz za {days} dni',
});
